import { Archive, CopyAll } from '@mui/icons-material'
import {
  Grid,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography
} from '@mui/material'
import { toast } from 'react-toastify'
import { useCopyToClipboard } from 'utils'
import {
  AutentiqueResponse,
  useLoadAutentiqueSignedProposals
} from './useLoadAutentiqueSignedProposals'
import VerifiedIcon from '@mui/icons-material/Verified'

type Props = {
  proposalId: string
  onSignedClick?: (item: AutentiqueResponse) => void
  disableConfirmButton?: boolean
}

export const AutentiqueSignedProposals = (props: Props) => {
  const { proposalId, onSignedClick, disableConfirmButton } = props
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, copy] = useCopyToClipboard()
  const { data: autentiqueSignedProposals } = useLoadAutentiqueSignedProposals({
    proposalId
  })

  const handleItemClick = (item: AutentiqueResponse) => {
    if (item.signed) window.open(item.files.signed, '_blank')
    else {
      copy(item.linkToSign)
      toast.success('Link gerado copiado!', {
        toastId: 'copyAutentiqueLink' + item.id
      })
    }
  }

  if (!autentiqueSignedProposals) return null

  return (
    <Grid item container xs={12}>
      {!!autentiqueSignedProposals?.length && (
        <>
          <Grid item xs={12}>
            <Typography variant="h6">
              Documentos enviados pelo Autentique
            </Typography>
          </Grid>

          <Grid item xs={12}>
            {autentiqueSignedProposals.map((item, index) => {
              return (
                <ListItem
                  disablePadding
                  key={item.id}
                  secondaryAction={
                    item.signed &&
                    disableConfirmButton && (
                      <Tooltip title="Confirmar assinatura">
                        <IconButton
                          edge="end"
                          onClick={() => onSignedClick?.(item)}
                        >
                          <VerifiedIcon color="success" />
                        </IconButton>
                      </Tooltip>
                    )
                  }
                >
                  <ListItemButton onClick={() => handleItemClick(item)}>
                    <ListItemIcon>
                      {item.signed ? <Archive /> : <CopyAll />}
                    </ListItemIcon>
                    <ListItemText
                      primary={`Documento ${index + 1}`}
                      secondary={
                        item.signed
                          ? 'Assinado, clique para ver o documento! '
                          : 'Não assinado, clique para copiar o link de assinatura!'
                      }
                    />
                  </ListItemButton>
                </ListItem>
              )
            })}
          </Grid>
        </>
      )}
    </Grid>
  )
}
